export const SUPER_ADMIN = 'SUPER_ADMIN';
export const ADMIN = 'ADMIN';
export const DELEGATION = 'DELEGATION';
export const ANALYTICS = 'ANALYTICS';
export const MANAGER = 'MANAGER';
export const PARTECIPANT = 'PARTECIPANT';
